import { Component } from '@angular/core';
import { CommonModule, NgIf, AsyncPipe } from '@angular/common';
import { ApiFeedbackService, FeedbackState } from '../../core/api-feedback.service';

@Component({
  standalone: true,
  selector: 'app-api-feedback',
  imports: [CommonModule, NgIf, AsyncPipe],
  template: `
    <ng-container *ngIf="fb.feedback$ | async as st">
      <div class="overlay" *ngIf="st.phase !== 'hidden'">
        <div class="box">
          <ng-container [ngSwitch]="st.phase">

            <div *ngSwitchCase="'loading'">
              <img src="/assets/alerts/loading.gif" class="icon" alt="Cargando…">
              <p>{{ st.text }}</p>
            </div>

            <div *ngSwitchCase="'success'">
              <img src="/assets/alerts/checked.svg" class="icon" alt="Éxito">
              <p>{{ st.text }}</p>
            </div>

            <div *ngSwitchCase="'error'">
              <img src="/assets/alerts/warning.svg" class="icon" alt="Error">
              <p>{{ st.text }}</p>
            </div>

          </ng-container>
        </div>
      </div>
    </ng-container>
  `,
  styles: [`
    .overlay {
      position: fixed; inset: 0;
      display: flex; align-items: center; justify-content: center;
      z-index: 200000;
    }
    .box {
      background: #fff; padding: 1.5rem 2rem;
      border-radius: 8px; text-align: center;
      box-shadow: 0 8px 16px rgba(0,0,0,0.2);
    }
    .icon {
      width: 48px; height: 48px; margin-bottom: 0.75rem;
    }
    p { margin:0; font-size:1rem; color:#333; }
  `]
})
export class ApiFeedbackComponent {
  constructor(public fb: ApiFeedbackService) {}
}
